(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ao-account-ui"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aoAccountUi) return;
    window.__aoAccountUi = true;

    function fillProvinces(country) {
      var target = document.getElementById(country.getAttribute('data-ao-province'));
      if (!target) return;
      var option = country.options[country.selectedIndex];
      var list = [];
      try {
        list = JSON.parse((option && option.getAttribute('data-provinces')) || '[]');
      } catch (e) {
        list = [];
      }
      var keep = target.value || target.getAttribute('data-default') || '';
      while (target.options.length) target.remove(0);
      list.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        target.appendChild(o);
      });
      if (keep) target.value = keep;
      if (!target.value && target.options.length) target.selectedIndex = 0;
      var wrap = target.closest('[data-ao-province-wrap]');
      if (wrap) wrap.hidden = list.length === 0;
      target.disabled = list.length === 0;
    }

    function initCountries(root) {
      (root || document).querySelectorAll('select[data-ao-country]').forEach(function (select) {
        if (select.__aoInit) return;
        select.__aoInit = true;
        var wanted = select.getAttribute('data-default');
        if (wanted) {
          for (var i = 0; i < select.options.length; i++) {
            if (select.options[i].value === wanted || select.options[i].text === wanted) {
              select.selectedIndex = i;
              break;
            }
          }
        }
        fillProvinces(select);
        select.addEventListener('change', function () {
          var target = document.getElementById(select.getAttribute('data-ao-province'));
          if (target) {
            target.value = '';
            target.removeAttribute('data-default');
          }
          fillProvinces(select);
        });
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-ao-toggle]');
      if (toggle) {
        var panel = document.getElementById(toggle.getAttribute('data-ao-toggle'));
        if (!panel) return;
        e.preventDefault();
        var open = panel.hidden;
        panel.hidden = !open;
        document.querySelectorAll('[data-ao-toggle="' + panel.id + '"]').forEach(function (t) {
          t.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        var host = panel.closest('[data-ao-expands]');
        if (host) host.classList.toggle('is-editing', open);
        if (open && window.AoMotion) window.AoMotion.enter(panel);
        if (open) {
          var first = panel.querySelector('input:not([type="hidden"]), select');
          if (first) first.focus();
        } else {
          toggle.focus();
        }
        return;
      }

      var reorder = e.target.closest('[data-ao-reorder]');
      if (reorder) {
        e.preventDefault();
        if (reorder.getAttribute('aria-busy') === 'true') return;
        var items = [];
        try {
          items = JSON.parse(reorder.getAttribute('data-items') || '[]');
        } catch (err) {
          items = [];
        }
        var status = document.getElementById(reorder.getAttribute('aria-describedby') || '');
        var say = function (key) {
          if (status) status.textContent = reorder.getAttribute(key) || '';
        };
        if (!items.length) {
          say('data-none');
          return;
        }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var post = function (list) {
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: list })
          }).then(function (r) {
            if (!r.ok) throw new Error('cart/add ' + r.status);
            return r.json();
          });
        };
        reorder.setAttribute('aria-busy', 'true');
        post(items)
          .catch(function () {
            var added = [];
            return items
              .reduce(function (chain, item) {
                return chain.then(function () {
                  return post([item]).then(function (res) {
                    added = added.concat(res.items || []);
                  }, function () {});
                });
              }, Promise.resolve())
              .then(function () {
                if (!added.length) throw new Error('none added');
                return { items: added, partial: true };
              });
          })
          .then(function (res) {
            say(res.partial ? 'data-partial' : 'data-added');
            document.dispatchEvent(new CustomEvent('ao:cart:added', { detail: { item: res } }));
          })
          .catch(function () {
            say('data-failed');
          })
          .then(function () {
            reorder.removeAttribute('aria-busy');
          });
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-ao-confirm]')) return;
      if (!window.confirm(form.getAttribute('data-ao-confirm'))) e.preventDefault();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initCountries(); });
    } else {
      initCountries();
    }
    document.addEventListener('shopify:section:load', function (e) { initCountries(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-catalogue-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ao-ctabs-scroll')) {
    customElements.define('ao-ctabs-scroll', class extends HTMLElement {
      connectedCallback() {
        const nav = this.querySelector('.ao-ctabs');
        const list = this.querySelector('.ao-ctabs__list');
        if (!nav || !list) return;
        const update = () => {
          nav.toggleAttribute('data-fade-end', list.scrollWidth - list.clientWidth - list.scrollLeft > 4);
        };
        this.update = update;
        list.addEventListener('scroll', update, { passive: true });
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(update);
          this.ro.observe(list);
        } else {
          window.addEventListener('resize', update);
        }
        const active = list.querySelector('[aria-current="page"]');
        if (active && list.scrollWidth > list.clientWidth) {
          active.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'instant' });
        }
        update();
      }
      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('resize', this.update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aoCardWarm) return;
    window.__aoCardWarm = true;
    var warmed = typeof WeakSet === 'function' ? new WeakSet() : null;
    var warm = function (event) {
      if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
      var card = event.target && event.target.closest ? event.target.closest('.ao-card') : null;
      if (!card || (warmed && warmed.has(card))) return;
      if (warmed) warmed.add(card);
      var img = card.querySelector('.ao-card__img--hover');
      if (!img || img.complete) return;
      img.setAttribute('data-card-pending', '');
      var done = function () { img.removeAttribute('data-card-pending'); };
      img.addEventListener('load', function () {
        if (img.decode) img.decode().then(done, done);
        else done();
      }, { once: true });
      img.addEventListener('error', done, { once: true });
      img.loading = 'eager';
    };
    document.addEventListener('pointerover', warm, { passive: true });
    document.addEventListener('focusin', warm);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-select"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ao-select')) {
    let uid = 0;
    const GAP = 4;
    const EDGE = 16;
    const CHECK =
      '<svg class="ao-select__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
    const canPopover = typeof HTMLElement.prototype.showPopover === 'function';

    class AoSelect extends HTMLElement {
      connectedCallback() {
        if (this.button) return;
        const select = this.querySelector('select');
        if (!select) return;
        this.select = select;
        this.uid = 'ao-select-' + ++uid;
        const label = this.querySelector('label[id]');

        const button = (this.button = document.createElement('button'));
        button.type = 'button';
        button.className = 'ao-select__control ao-select__trigger';
        button.id = this.uid + '-trigger';
        button.setAttribute('role', 'combobox');
        button.setAttribute('aria-haspopup', 'listbox');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', this.uid + '-list');
        const value = (this.valueEl = document.createElement('span'));
        value.id = this.uid + '-value';
        value.className = 'ao-select__value';
        button.appendChild(value);
        button.setAttribute('aria-labelledby', (label ? label.id + ' ' : '') + value.id);

        const list = (this.list = document.createElement('div'));
        list.className = 'ao-select__list';
        list.id = this.uid + '-list';
        list.setAttribute('role', 'listbox');
        list.tabIndex = -1;
        if (label) list.setAttribute('aria-labelledby', label.id);
        if (canPopover) list.setAttribute('popover', 'manual');
        else list.hidden = true;

        select.after(button);
        this.appendChild(list);
        select.tabIndex = -1;
        select.setAttribute('aria-hidden', 'true');
        this.classList.add('ao-select--js');
        this.render();

        this.typed = '';
        this.on = [
          [select, 'focus', () => button.focus()],
          [select, 'change', () => this.render()],
          [button, 'click', () => (this.isOpen ? this.close() : this.open())],
          [button, 'keydown', (e) => this.onKey(e)],
          [button, 'blur', () => this.onBlur()],
          [list, 'mousedown', (e) => e.preventDefault()],
          [list, 'click', (e) => this.onPick(e)],
          [list, 'mousemove', (e) => this.onHover(e)],
          [window, 'pageshow', () => this.render()],
        ];
        this.on.forEach(([el, type, fn]) => el.addEventListener(type, fn));
        this.onOutside = (e) => {
          if (!this.contains(e.target)) this.close();
        };
        this.onViewport = (e) => {
          if (e.target === list) return;
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.place());
        };
      }

      disconnectedCallback() {
        if (!this.button) return;
        this.close(true);
        this.on.forEach(([el, type, fn]) => el.removeEventListener(type, fn));
      }

      get isOpen() {
        return this.hasAttribute('data-open');
      }

      options() {
        return Array.from(this.list.children);
      }

      render() {
        const select = this.select;
        const current = select.options[select.selectedIndex];
        this.valueEl.textContent = current ? current.text.trim() : '';
        this.list.replaceChildren(
          ...Array.from(select.options).map((option, i) => {
            const el = document.createElement('div');
            el.className = 'ao-select__option';
            el.id = this.uid + '-opt-' + i;
            el.setAttribute('role', 'option');
            el.setAttribute('aria-selected', option.selected ? 'true' : 'false');
            if (option.disabled) el.setAttribute('aria-disabled', 'true');
            el.dataset.index = i;
            const text = document.createElement('span');
            text.className = 'ao-select__text';
            text.textContent = option.text.trim();
            el.appendChild(text);
            el.insertAdjacentHTML('beforeend', CHECK);
            return el;
          })
        );
      }

      enabled(i) {
        const option = this.select.options[i];
        return !!option && !option.disabled;
      }

      // Next enabled index from `from` moving by `step`, clamped (no wrap).
      seek(from, step) {
        const n = this.select.options.length;
        for (let i = from; i >= 0 && i < n; i += step) if (this.enabled(i)) return i;
        return -1;
      }

      setActive(i, kbd) {
        if (i < 0) return;
        this.options().forEach((el) => el.removeAttribute('data-active'));
        const el = this.list.children[i];
        if (!el) return;
        this.active = i;
        el.setAttribute('data-active', '');
        this.list.toggleAttribute('data-kbd', !!kbd);
        this.button.setAttribute('aria-activedescendant', el.id);
        const top = el.offsetTop;
        const bottom = top + el.offsetHeight;
        const pad = parseFloat(getComputedStyle(this.list).paddingTop) || 0;
        if (top - pad < this.list.scrollTop) this.list.scrollTop = top - pad;
        else if (bottom + pad > this.list.scrollTop + this.list.clientHeight) this.list.scrollTop = bottom + pad - this.list.clientHeight;
      }

      open(start, kbd) {
        if (this.isOpen) return;
        clearTimeout(this.hideTimer);
        this.render();
        const list = this.list;
        if (canPopover) {
          if (!list.matches(':popover-open')) list.showPopover();
        } else list.hidden = false;
        this.place();
        list.offsetWidth;
        this.setAttribute('data-open', '');
        list.setAttribute('data-open', '');
        this.button.setAttribute('aria-expanded', 'true');
        let i = typeof start === 'number' ? start : this.select.selectedIndex;
        if (!this.enabled(i)) i = this.seek(Math.max(i, 0), 1);
        if (i < 0) i = this.seek(this.select.options.length - 1, -1);
        this.setActive(i, kbd);
        document.addEventListener('pointerdown', this.onOutside, true);
        window.addEventListener('scroll', this.onViewport, { capture: true, passive: true });
        window.addEventListener('resize', this.onViewport, { passive: true });
      }

      close(now) {
        if (!this.isOpen && !now) return;
        const list = this.list;
        this.removeAttribute('data-open');
        list.removeAttribute('data-open');
        this.button.setAttribute('aria-expanded', 'false');
        this.button.removeAttribute('aria-activedescendant');
        document.removeEventListener('pointerdown', this.onOutside, true);
        window.removeEventListener('scroll', this.onViewport, { capture: true });
        window.removeEventListener('resize', this.onViewport);
        cancelAnimationFrame(this.raf);
        const hide = () => {
          if (list.hasAttribute('data-open')) return;
          if (canPopover) {
            if (list.matches(':popover-open')) list.hidePopover();
          } else list.hidden = true;
        };
        clearTimeout(this.hideTimer);
        if (now) return hide();
        const ms = parseFloat(getComputedStyle(list).transitionDuration) * 1000 || 0;
        this.hideTimer = setTimeout(hide, ms + 20);
      }

      place() {
        const list = this.list;
        const r = this.button.getBoundingClientRect();
        const vw = document.documentElement.clientWidth;
        const vh = window.innerHeight;
        const maxW = vw - EDGE * 2;
        list.style.minWidth = Math.min(r.width, maxW) + 'px';
        list.style.maxWidth = maxW + 'px';
        list.style.maxHeight = '';
        const below = vh - r.bottom - GAP - EDGE;
        const above = r.top - GAP - EDGE;
        const natural = Math.min(list.scrollHeight + 2, 320);
        const up = natural > below && above > below;
        const room = Math.max(up ? above : below, 120);
        const height = Math.min(natural, room);
        list.style.maxHeight = Math.min(320, room) + 'px';
        list.dataset.placement = up ? 'top' : 'bottom';
        const width = list.offsetWidth;
        const rtl = getComputedStyle(this).direction === 'rtl';
        let left = rtl ? r.right - width : r.left;
        if (left + width > vw - EDGE) left = r.right - width;
        left = Math.max(EDGE, Math.min(left, vw - EDGE - width));
        list.style.left = Math.round(left) + 'px';
        list.style.top = Math.round(up ? r.top - GAP - height : r.bottom + GAP) + 'px';
      }

      choose(i) {
        if (!this.enabled(i)) return;
        const select = this.select;
        const changed = select.selectedIndex !== i;
        select.selectedIndex = i;
        this.close();
        this.render();
        this.button.focus();
        if (!changed) return;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onPick(event) {
        const el = event.target.closest('.ao-select__option');
        if (!el) return;
        this.choose(Number(el.dataset.index));
      }

      onHover(event) {
        const el = event.target.closest('.ao-select__option');
        if (!el || !this.enabled(Number(el.dataset.index))) return;
        if (Number(el.dataset.index) !== this.active || this.list.hasAttribute('data-kbd')) this.setActive(Number(el.dataset.index), false);
      }

      onBlur() {
        setTimeout(() => {
          if (this.isOpen && !this.contains(document.activeElement)) this.close();
        });
      }

      typeahead(key) {
        clearTimeout(this.typeTimer);
        this.typeTimer = setTimeout(() => (this.typed = ''), 600);
        const repeat = this.typed === key;
        this.typed = repeat ? key : this.typed + key;
        const term = this.typed.toLowerCase();
        const opts = Array.from(this.select.options);
        const from = this.isOpen ? this.active : this.select.selectedIndex;
        const order = opts.map((_, n) => (from + (repeat || term.length === 1 ? 1 : 0) + n) % opts.length);
        const hit = order.find((n) => this.enabled(n) && opts[n].text.trim().toLowerCase().startsWith(term));
        return hit === undefined ? -1 : hit;
      }

      onKey(event) {
        const key = event.key;
        const open = this.isOpen;
        const last = this.select.options.length - 1;
        if (event.ctrlKey || event.metaKey) return;
        if (!open) {
          if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter' || key === ' ') {
            event.preventDefault();
            this.open(undefined, true);
          } else if (key === 'Home') {
            event.preventDefault();
            this.open(this.seek(0, 1), true);
          } else if (key === 'End') {
            event.preventDefault();
            this.open(this.seek(last, -1), true);
          } else if (key.length === 1 && key !== ' ' && !event.altKey) {
            const hit = this.typeahead(key);
            this.open(hit >= 0 ? hit : undefined, true);
          }
          return;
        }
        let next = -1;
        switch (key) {
          case 'ArrowDown':
            if (event.altKey) return;
            next = this.seek(this.active + 1, 1);
            break;
          case 'ArrowUp':
            if (event.altKey) {
              event.preventDefault();
              this.choose(this.active);
              return;
            }
            next = this.seek(this.active - 1, -1);
            break;
          case 'Home':
            next = this.seek(0, 1);
            break;
          case 'End':
            next = this.seek(last, -1);
            break;
          case 'PageDown':
            next = this.seek(Math.min(this.active + 10, last), -1);
            break;
          case 'PageUp':
            next = this.seek(Math.max(this.active - 10, 0), 1);
            break;
          case 'Enter':
            event.preventDefault();
            this.choose(this.active);
            return;
          case ' ':
            event.preventDefault();
            if (this.typed) next = this.typeahead(' ');
            else {
              this.choose(this.active);
              return;
            }
            break;
          case 'Escape':
            event.preventDefault();
            event.stopPropagation();
            this.close();
            return;
          case 'Tab':
            this.close();
            return;
          default:
            if (key.length === 1 && !event.altKey) next = this.typeahead(key);
            else return;
        }
        event.preventDefault();
        if (next >= 0) this.setActive(next, true);
      }
    }
    customElements.define('ao-select', AoSelect);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-side-index"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ao-side-index')) {
    class AoSideIndex extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.ao-sidx__list');
        if (!this.list) return;
        if (this.dataset.source) this.build();
        this.links = Array.from(this.list.querySelectorAll('a[href^="#"]'));
        this.targets = this.links.map((a) => document.getElementById(decodeURIComponent(a.hash.slice(1))));
        if (!this.links.length) return;
        this.onScroll = this.onScroll.bind(this);
        this.placeTick = this.placeTick.bind(this);
        this.links.forEach((a, i) => a.addEventListener('click', (e) => this.go(e, i)));
        this.tick = this.list.querySelector('.ao-sidx__tick');
        if (!this.tick) {
          this.tick = document.createElement('li');
          this.tick.className = 'ao-sidx__tick';
          this.tick.setAttribute('aria-hidden', 'true');
          this.tick.setAttribute('role', 'presentation');
          this.tick.hidden = true;
          this.list.appendChild(this.tick);
        }
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        if (window.ResizeObserver) {
          this.ro = new ResizeObserver(() => this.placeTick());
          this.ro.observe(this.list);
        }
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.ro) this.ro.disconnect();
      }

      reduced() {
        return window.AoMotion ? window.AoMotion.reduced() : window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      placeTick() {
        const t = this.tick;
        const a = this.links && this.links[this.current];
        if (!t) return;
        if (!a || !a.offsetParent) {
          t.hidden = true;
          return;
        }
        const lr = this.list.getBoundingClientRect();
        const ar = a.getBoundingClientRect();
        const s = t.style;
        s.setProperty('--ao-tick-y', ar.top - lr.top - this.list.clientTop + this.list.scrollTop + 'px');
        s.setProperty('--ao-tick-h', ar.height);
        s.setProperty('--ao-tick-x', ar.left - lr.left - this.list.clientLeft + this.list.scrollLeft + 'px');
        s.setProperty('--ao-tick-w', ar.width);
        if (t.hidden) {
          t.hidden = false;
          requestAnimationFrame(() => requestAnimationFrame(() => t.classList.add('is-ready')));
        }
      }

      slug(text) {
        return text
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 60);
      }

      build() {
        const root = document.querySelector(this.dataset.source);
        const min = parseInt(this.dataset.min, 10) || 2;
        if (!root) return;
        const heads = Array.from(root.querySelectorAll('h2')).filter((h) => h.textContent.trim());
        if (heads.length < min) {
          this.hidden = true;
          return;
        }
        const used = new Set();
        this.list.textContent = '';
        heads.forEach((h, i) => {
          if (!h.id) {
            let id = 'ao-' + (this.slug(h.textContent) || 'section-' + (i + 1));
            let n = 2;
            while (used.has(id) || document.getElementById(id)) id = id.replace(/-\d+$/, '') + '-' + n++;
            h.id = id;
          }
          used.add(h.id);
          const li = document.createElement('li');
          li.className = 'ao-sidx__item';
          const a = document.createElement('a');
          a.className = 'ao-sidx__link';
          a.href = '#' + encodeURIComponent(h.id);
          a.textContent = h.textContent.trim().replace(/\s+/g, ' ');
          li.appendChild(a);
          this.list.appendChild(li);
        });
        this.hidden = false;
        this.dispatchEvent(new CustomEvent('ao-side-index:built', { bubbles: true }));
      }

      offset() {
        let top = 0;
        const header = document.querySelector('.ao-header--sticky');
        const wrap = header ? header.closest('.shopify-section') || header : null;
        if (wrap) {
          const r = wrap.getBoundingClientRect();
          if (r.bottom > 0 && r.top <= 0) top = r.bottom;
          else if (getComputedStyle(wrap).position === 'sticky') top = r.height;
        }
        return Math.round(top);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          const off = this.offset();
          const root = this.closest('[data-ao-sticky-root]') || this.parentElement;
          if (root) root.style.setProperty('--ao-sticky-top', off + 24 + 'px');
          const line = off + 48;
          let active = 0;
          this.targets.forEach((t, i) => {
            if (t && t.getBoundingClientRect().top - line <= 0) active = i;
          });
          if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
            const last = this.targets.length - 1;
            const lt = this.targets[last];
            if (lt && lt.getBoundingClientRect().top < window.innerHeight) active = last;
          }
          this.setActive(active);
        });
      }

      setActive(i) {
        if (this.current === i) return;
        this.current = i;
        this.links.forEach((a, k) => {
          if (k === i) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
        this.placeTick();
        const a = this.links[i];
        if (a && this.list.scrollWidth > this.list.clientWidth + 1) {
          const lr = this.list.getBoundingClientRect();
          const ar = a.getBoundingClientRect();
          const behavior = this.reduced() ? 'auto' : 'smooth';
          if (i === 0) this.list.scrollTo({ left: 0, behavior: behavior });
          else if (ar.left < lr.left || ar.right > lr.right) {
            this.list.scrollTo({ left: Math.max(0, this.list.scrollLeft + ar.left - lr.left - 20), behavior: behavior });
          }
        }
      }

      go(e, i) {
        const t = this.targets[i];
        if (!t) return;
        e.preventDefault();
        const reduce = this.reduced();
        const top = t.getBoundingClientRect().top + window.scrollY - this.offset() - 24;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
        t.focus({ preventScroll: true });
        if (history.replaceState) history.replaceState(null, '', '#' + encodeURIComponent(t.id));
        this.setActive(i);
      }
    }
    customElements.define('ao-side-index', AoSideIndex);
  }
  } catch(e) { console.error(e); }
})();

})();
